import Image from "@components/Image";
import TitleTranslateBtn from "@components/TitleTranslateBtn";
import type { UICardProps } from "./types";
import { FocusAction } from "./FocusAction";

const UIProductCard = ({ record }: UICardProps) => {
  return (
    <div key={record.id} className="kalo-white-card flex flex-col relative w-full group cursor-pointer overflow-hidden">
      <Image className="w-full aspect-square rounded-none border-none! shrink-0" url={record.coverImageUrl}></Image>
      <div className="py-[8px] px-[12px]">
        <div className="h-[42px] flex flex-row justify-between flex-start">
          <span className="line-clamp-2 text-kds-fg text-[14px]">{record.productTitle}</span>
          <span className="mt-[2px]">
            <TitleTranslateBtn info={{ ...record, type: "product", product_title: record.productTitle }} />
          </span>
        </div>
        <div className="mt-[4px] mb-[8px] text-[16px] font-semibold text-kds-fg">
          {record.maxRealPrice === record.minRealPrice
            ? record.maxRealPrice
            : `${record.minRealPrice} - ${record.maxRealPrice}`}
        </div>
      </div>
      <FocusAction
        className="absolute right-[11px] top-[11px] hidden group-hover:flex"
        id={record.id}
        type="product"
      ></FocusAction>
    </div>
  );
};

export default UIProductCard;
